/**
 * Product Generic Grid Service - Get all required data
 *
 * @memberof Product-Generic-Grid
 */
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Data Model
import {
    ProductModel,
    EnviormentConfig,
    ProductGenericGridResponseModel
} from 'abs-ngx-library/src/lib/core';
// Services
import { ProductCatalogALV1Service } from './product-catalog-al-v1.service';
import { CommonService, UserInfoService, P13nEndpointService } from 'abs-ngx-library/src/lib/core';
 import { GenericGridDataResponse, GenericGridDataObj } from './models/grid-data.model';import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';

// jQuery
declare let $: any;

interface OTASearchPayload {
    searchQuery?: string;
    start?: number;
    rows?: number;
    fulfillmentType?: string;
    nextPageToken?: string;
}

@Injectable()
export class ProductGenericGridALV1Service {
    private _config = EnviormentConfig;
    private _currentEnv;

    private defaultNoResultsMsg = 'No products available.';
    public objGridData: GenericGridDataObj = {
        drivenType: '',
        apiUrl: '',
        apiType: '',
        sorts: '',
        defaultSort: '',
        value: {},
        products: [],
        widgetId: '',
        badgePreference:'',
        badgeList: ''
    };

    public constructor(
        private _http: HttpClient,
        private _productCatalogALV1Service: ProductCatalogALV1Service,
        private _commonService: CommonService,
        private _userInfoService: UserInfoService,
        private _p13nEndpointService : P13nEndpointService
    ) {
        this._currentEnv = this._commonService.getCurrentEnviorment();
    }

    public getData() {
        if (this.hasDynamicData() && !this.objGridData.doGenericFlow) {
            return this.getDynamicData();
        } else if (this.hasStaticData()) {
            return this.getStaticData();
         } else if (this.objGridData.doGenericFlow) {
            return this.getGenericData();
        }
        return of({
            'products': [],
            'offersData': {},
        });
    }

     private getGenericData(): Observable<GenericGridDataResponse> {
        let objHttp: Observable<any> = of([]);
        switch (this.objGridData.drivenType) {
            case 'generic':
                objHttp = this.getP13nProductsData();
        }
        return objHttp;
     }

     private getP13nProductsData(): Observable<GenericGridDataResponse> {
        const dynamicFields = {modelConfigurationId: this.objGridData.modelConfigurationId, uiPageSize: 135, excludeCartItems: true, excludeOOS: true};
        const payload = this._p13nEndpointService.generateProductsRequestPayload(dynamicFields);
        return this._p13nEndpointService.getP13nProductsRecommendation(payload).pipe(map((response) => {
            return {products: response?.productsinfo, p13nAdobeMetrics: response?.p13nAdobeMetrics, offersData: response?.offersData} as GenericGridDataResponse;
        }));
     }
    
    private getDynamicData() {
        let objHttp: any = of([]);
        this.objGridData.drivenType = 'catalog';

        switch (this.objGridData.drivenType) {
            case 'catalog':
                objHttp = this._productCatalogALV1Service.getCatalogData(this.objGridData);
                break;
            case 'purchase':
                objHttp = this.getPurchaseData(this.objGridData);
                break;
            case 'relevancy':
                objHttp = this.getRelevancyData();
                break;
            default:
                objHttp = this.getDotNetData();
                break;
        }

        return objHttp;
    }

    private getRelevancyData() {
        let objObservable = of({});
        let relevancyUrl = '';
        let bpn: string;
        let hhid: string;
        let storeId: string;
        let bearerToken: string;
        let httpOptions: any;
        const xAPIBasePath = 'https://www.safeway.com/abs/pub/xapi';
        //window['SWY'].CONFIGSERVICE.getDatapowerConfig().datapowerxAPIBasePath; //

        switch (true) {
            case (this.objGridData.apiType === 'similar-products'):
                bpn = window['AB']['COMMON'].getURLParameterByName('bpn');
                storeId = window['AB'] && window['AB']['userInfo'] && window['AB']['userInfo']['branchId']
                    ? window['AB']['userInfo']['branchId'] : '';
                relevancyUrl = `${xAPIBasePath}/pdreco/similarproducts?bpn=${bpn}&storeId=${storeId}`;
                httpOptions = {
                    headers: new HttpHeaders({
                        'Ocp-Apim-Subscription-Key': '7bad9afbb87043b28519c4443106db06',
                        'accept': 'application/json'
                    })
                };
                break;

            case (this.objGridData.apiType === 'substitution'):
                bpn = window['AB']['COMMON'].getURLParameterByName('bpn');
                hhid = window['AB'] && window['AB']['userInfo'] && window['AB']['userInfo']['houseId'] && window['AB']['COMMON'].getURLParameterByName('hhid')
                    ? window['AB']['COMMON'].getURLParameterByName('hhid') : '';
                storeId = window['AB'] && window['AB']['userInfo'] && window['AB']['userInfo']['branchId']
                    ? window['AB']['userInfo']['branchId'] : '';
                relevancyUrl = `${xAPIBasePath}/pdreco/substitution?bpn=${bpn}&storeId=${storeId}&hhid=${hhid}`;
                httpOptions = {
                    headers: new HttpHeaders({
                        'Ocp-Apim-Subscription-Key': '7bad9afbb87043b28519c4443106db06',
                        'accept': 'application/json'
                    })
                };
                break;

            case (!!this.objGridData.widgetId && !!this.objGridData.apiType):
                // HARD - CODED URL FOR POC ONLY //
                const query: string = window['AB']['COMMON'].getURLParameterByName('query');
                const item_ids: string = window['AB']['COMMON'].getURLParameterByName('item_ids');
                relevancyUrl = 'https://pathways.dxpapi.com/api/v2/widgets/' + this.objGridData.apiType + '/'
                    + this.objGridData.widgetId
                    + '?_br_uid_2=uid%3D2582397584083%3Av%3D12.0%3Ats%3D1587279462499%3Ahc%3D358&account_id=6175&url=www.bloomique.com&domain_key=albertsons&request_id=1597706996821&fields=name%2CaisleId%2Cpid%2Cupc%2Cprice%2CbasePrice%2CpricePer%2Cquantity%2CquantityOrder%2CunitOfMeasure%2CpromoDescription%2CsalesRank%2CdepartmentName%2CpromoType%2CpromoTitle%2CpromoText%2CofferText%2CpromoEndDate%2CrestrictedValue&rows=30&start=0&query=' + query + '&item_ids=' + item_ids;
                // const apimKey = window['SWY']['CONFIGSERVICE']['omsConfig']['swy.api.purchase.service.purchases.apim.key']
                bearerToken = window['AB']['userInfo']['SWY_SHOP_TOKEN'];
                httpOptions = {
                    headers: new HttpHeaders({
                        'ocp-apim-subscription-key': 'e914eec9448c4d5eb672debf5011cf8f',
                        'Authorization': 'Bearer ' + bearerToken,
                        'accept': 'application/json'
                    })
                };
                break;
            default:
                // HARD - CODED URL FOR POC ONLY //
                bpn = window['AB']['COMMON'].getURLParameterByName('bpn');
                relevancyUrl = 'https://www.safeway.com/api/v1/core/Search_Results?account_id=6175&auth_key=eyxny75nafpl1ra4&domain_key=albertsons&request_id=8913801407865&_br_uid_2=uid%253D4195525208755%253Av%253D12.0%253Ats%253D1602201845750%253Ahc%253D90&url=https://www.safeway.com&ref_url=https://www.safeway.com&request_type=mlt&fl=name,aisleId,pid,upc,price,basePrice,pricePer,quantity,quantityOrder,unitOfMeasure,promoDescription,salesRank,departmentName,promoType,promoTitle,promoText,offerText,promoEndDate,restrictedValue,unitQuantity,displayEstimateText,displayUnitQuantityText&rows=12&start=0&sort=&view_id=1502&pid='
                    + bpn + '&facet=false';
                // const apimKey = window['SWY']['CONFIGSERVICE']['omsConfig']['swy.api.purchase.service.purchases.apim.key']
                bearerToken = window['AB']['userInfo']['SWY_SHOP_TOKEN'];
                httpOptions = {
                    headers: new HttpHeaders({
                        'ocp-apim-subscription-key': 'e914eec9448c4d5eb672debf5011cf8f',
                        'Authorization': 'Bearer ' + bearerToken,
                        'accept': 'application/json'
                    })
                };
                break;
        }

        relevancyUrl += `&includeOffer=true`;

        objObservable = this._http.get<ProductGenericGridResponseModel>(relevancyUrl, httpOptions).pipe(
            catchError(() => of({ purchases: null, offersData: {}, purchasesCount: 0 }))
        );

        return objObservable;
    }

    private getPurchaseData(apiData: any) {
        let objObservable = of({});

        const apimKey = window['SWY']['CONFIGSERVICE']['omsConfig']['swy.api.purchase.service.purchases.apim.key'];
        const bearerToken = window['AB']['userInfo']['SWY_SHOP_TOKEN'];
        const httpOptions = {
            headers: new HttpHeaders({
                'ocp-apim-subscription-key': apimKey,
                'Authorization': 'Bearer ' + bearerToken,
                'accept': 'application/json'
            })
        };

        let purchasesUrl = apiData.apiUrl;
        const storeId = window['AB'] && window['AB']['userInfo'] && window['AB']['userInfo']['branchId']
            ? window['AB']['userInfo']['branchId']
            : '';

        switch (apiData.apiType) {
            case 'buy-it-again':
                break;

            default:
                const customerId = window['AB'] && window['AB']['userInfo'] && window['AB']['userInfo']['customerId']
                    ? window['AB']['userInfo']['customerId']
                    : '';
                purchasesUrl = `${purchasesUrl}/${customerId}?storeId=${storeId}`;

                purchasesUrl = this._commonService.generateCBAUrl(purchasesUrl);
                purchasesUrl += `&includeOffer=true`;

                objObservable = this._http
                    .get<ProductGenericGridResponseModel>(purchasesUrl, httpOptions).pipe(
                        catchError((error) => {
                            return of({ purchases: null, purchasesCount: 0, offersData: {} });
                        })
                    )
                break;
        }

        return objObservable;
    }

    private getDotNetData() {
        let strUrl: string = window['AB']['gridDataURL'];

        switch (this.objGridData.drivenType) {

            case 'erumslastorder':
                const url = window['SWY']['CONFIGSERVICE'].erumsConfig['orders.service.endpoint'] + '/orders/latest?includeOffer=true';
                return this._http.get<ProductGenericGridResponseModel>(url, {
                    headers: new HttpHeaders(window['AB']['lastOrderErumsHttpOptions'])
                }).pipe(
                    catchError(() => of({ ack: true, products: [], offersData: {} }))
                );
            case 'search':
                strUrl = this._replaceSearchValue(strUrl) + '&storeId=' + window['AB']['userInfo']['branchId'] + '&includeOffer=true';
                return this._http.get<ProductGenericGridResponseModel>(strUrl);

            case 'bogo':
            case 'rewardcard':
                break;

            case 'promo':
            case 'recipe':
            case 'dynamicpromo':
                strUrl += '&storeId=' + window['AB']['userInfo']['branchId'] + '&includeOffer=true';
                return this._http.get<ProductGenericGridResponseModel>(strUrl);

            case 'historylist':
                const strRand = (Math.floor((Math.random() * 1000000)));
                strUrl += '&rand=' + strRand + '&storeId=' + window['AB']['userInfo']['branchId'] + '&includeOffer=true';
                return this._http.get<ProductGenericGridResponseModel>(strUrl).pipe(
                    catchError(() => of({ ack: true, products: [], offerData: {} }))
                );

            default:
                return this._http.get<ProductGenericGridResponseModel>(strUrl);
        }
    }

    private getAllBrands() {
        const strUrl = this._replaceSearchValue(window['AB']['gridDataURLNoParam']);
        return this._http.get<ProductModel[]>(strUrl);
    }

    /*
        The below method is used to get static data for the product grid. There is no API call made here.
     */

    public getStaticData() {
        return of({
            'products': this.objGridData.products,
            'offersData': {},
        });
    }

    public getUpdatedData(aisleId) {
        if (aisleId != null) {
            // delete last _number from aisleId since it comes as a sub-aisle of the aisle we need to make the request for
            aisleId = aisleId.slice(0, -2);
        }
        const url = window['AB']['aemAislePath'] + '?aisleId=' + aisleId + '&storeId=' + window['AB']['userInfo']['branchId'];

        // update analytics data layer, need to set the aisle id for the level 2 aisle page
        $(function () { window['AB']['DATALAYER'].productInfo({ aisleId: aisleId }); });

        return this._http.get<any>(url);
    }

    private hasDynamicData() {
        if (this.objGridData.drivenType === 'static') {
            return false;
        } else {
            if (window['AB']['gridDataURL'] || this.objGridData.apiUrl || this.objGridData.drivenType === 'relevancy') {
                return true;
            } else {
                return false;
            }
        }
    }

    private hasBrandUrl() {
        return window['AB']['gridDataURLNoParam'] && window['AB']['gridDataURLNoParam'].length;
    }

    private hasStaticData() {
        return this.objGridData.products.length > 0;
    }

    public getNoResultsMsg(productGridPage) {
        let results;
        switch (productGridPage) {
            case 'shelf-page':
            case 'promo':
            case 'rewardcard':
            case 'bogo':
            case 'catalog':
            case 'erumslastorder':
            case 'historylastorder':
            case 'historylist':
                results = window['AB']['errorText'] || this.defaultNoResultsMsg;
                break;
            case 'search':
                results = `<div class='no-result'><div class=container'><dl>
                 <dd>Check for typos.</dd><dd>Be more general (e.g. \"carrots\" instead of \"bags of carrots\")</dd>
                 <dd>Try looking within the aisles shown below</dd>
                 </dl></div></div>`;
                break;
            default:
                results = '<span>No items are available.</span>';
                break;
        }
        return results;
    }

    public extractBrand() {
        let result = Observable.create((obs) => {
            obs.next({ 'ack': true });
            obs.complete();
        });
        if (this.hasBrandUrl()) {
            result = this.getAllBrands();
        }
        return result;
    }

    public areAllProductsUnavailable(products) {
        let isUnavailable = true;
        if (!Array.isArray(products)) {
            return false;
        }
        products.forEach((product) => {
            if (product.price !== 0) {
                isUnavailable = false;
            }
        });
        return isUnavailable;
    }

    private _replaceSearchValue(strUrl: string): any {
        let searchQuery: string = window['AB']['COMMON'].getURLParameterByName('q');

        if (searchQuery == null) {
            searchQuery = '';
        } else {
            searchQuery = decodeURIComponent(searchQuery);
            searchQuery = encodeURIComponent(searchQuery);
        }

        strUrl = strUrl.replace(/\(searchTerm\)/g, searchQuery);
        let searchBrand: string = window['AB']['COMMON'].getURLParameterByName('brand');

        if (searchBrand == null) {
            searchBrand = '';
        } else {
            searchBrand = decodeURIComponent(searchBrand);
            searchBrand = encodeURIComponent(searchBrand);
        }

        strUrl = strUrl.replace(/\(searchBrand\)/g, searchBrand);
        return strUrl;
    }

    public getMoreSearchProducts({
        searchQuery,
        start,
        rows,
        fulfillmentType,
        nextPageToken
    }: OTASearchPayload) {
        const searchProductsPath = this._config[this._currentEnv].searchProductsAPIDetails.searchProductsAPI;
        const basePath = this._config[this._currentEnv].baseURL.replace('{banner}',this._userInfoService.getBanner());
        const queryParams = {
            pageurl: basePath,
            url: basePath,
            "request-id": this._getUTCTimeStampRandom(),
            pagename: 'search',
            rows,
            start,
            'search-type': 'keyword',
            storeid: this._userInfoService.getShopStoreId(),
            q: searchQuery,
            dvid: 'GhXAoLXN-ss-search',
            channel: fulfillmentType,
            uuid: this._userInfoService.getUUID(),
            featured: false,
            banner: this._userInfoService.getBanner(),
            includeOffer: true
        }
        if(nextPageToken) queryParams['nextPageToken'] = nextPageToken;
        const queryParamsStr = Object.keys(queryParams).map(key => key + '=' + queryParams[key]).join('&');
        const url = `/${searchProductsPath}?${queryParamsStr}`;
        const httpOptions = {
            headers: new HttpHeaders({
                'ocp-apim-subscription-key': this._config[this._currentEnv].searchProductsAPIDetails.subscriptionKey.value,
                'accept': 'application/json'
            })
        };
        return this._http.get(url, httpOptions).pipe(                 
        map((searchResponseData) => {
            const returnObj = {
                products: searchResponseData?.['primaryProducts']?.['response']?.['docs'],
                offers: searchResponseData?.['offersData'],
                nextPageToken: searchResponseData?.['primaryProducts']?.['response']?.['miscInfo']?.['nextPageToken'],
            }
            return returnObj;
        }),
        catchError(
            error => {
                return throwError(Error("Error in getting products"));
            }
        ));
    }

    private _getUTCTimeStampRandom() {
        return Math.floor(Math.random() * (999 - 100 + 1) + 100).toString() + Date.now() + Math.floor(Math.random() * (999 - 100 + 1) + 100).toString();
    }

    /**
     * Calculates how many products can fit in a row for the redesigned product cards
     * @param containerElement Normally .pc-grid div DOM element.
     * @param productElement Normally .pc-grid-prdItem DOM element
     * @returns 
     */
    public calculateCardsPerRow(containerElement: HTMLElement, productElement: HTMLElement): number {
        if (containerElement !== null && productElement !== null) {
            return Math.round(containerElement.offsetWidth / productElement.offsetWidth);
        }
        return 0;
    }
    
    /**
     * Calculates and returns a map of indices for products that are the last in their respective rows in a grid layout.
     * 
     * @param products - The array of products displayed in the grid.
     * @param productsPerRow - The total number of products that can fit in a single row of the grid.
     * @returns A `Map` where:
     *   - The key represents the index of the product in the `products` array that is the last product in its row.
     *   - The value represents the 1-based row number that the product belongs to. This aligns with the gridZone `gridCarousels` object.
     * 
     * @example
     * // Example usage:
     * const products = [product1, product2, product3, product4, product5, product6];
     * const productsPerRow = 3;
     * const result = calculateFullWidthIndices(products, productsPerRow);
     * console.log(result); // Map { 2 => 1, 5 => 2 }
     * // Explanation:
     * // - Product at index 2 is the last in row 1.
     * // - Product at index 5 is the last in row 2.
     */
    public calculateFullWidthIndices(products: ProductModel[], productsPerRow: number): Map<number, number> {
        const indices = new Map<number, number>();
        if (products !== undefined && products !== null && productsPerRow > 0) {
            products.forEach((_, arrIndex) => {
                const rowIndex = Math.floor(arrIndex / productsPerRow) + 1;
                const isLastInRow = (arrIndex + 1) % productsPerRow === 0;

                // Need to wait for last row to show the grid zone. Everytime we calc gridzone placement, it will 
                // Cause a rerender. Thus, all items in the gridzone will be rerendered. 
                // This is not allowed, as it would re trigger impressions on components like master product carousel.
                if (isLastInRow) {
                    indices.set(arrIndex, rowIndex);
                }
            })

        }
        return indices;
    }
}
